import requestBase from './request.js'
import apis from './apis'
import LightMobileCall from '@kugou/light-mobilecall'
import infSign from "@kugou/interface-signature"
import {getQueryString} from '../Utils/Utils'
import e from '../Utils/Event'
import apm from '../Utils/collect/apm.js'

export default (baseUrl, { noSign } = {}) => {
  let request = requestBase(baseUrl)
  return (apiName, params, configs) => {
    //单独处理get_face_status
    if(apiName.indexOf('get_face_status') > -1) request = requestBase(baseUrl, 10000)
    if (!apis[apiName]) {
      throw new ReferenceError('nothing api match!:', apiName)
    }

    const userBase = {
      kugouid: getQueryString("debug") && getQueryString("kugouid") ? getQueryString("kugouid") : window.$userInfo.userid,
      userid: getQueryString("debug") && getQueryString("kugouid") ? getQueryString("kugouid") : window.$userInfo.userid,
      appid: window.$userInfo.appid,
      token: window.$userInfo.token,
      dfid: window.$userInfo.dfid || '-',//风控需要传正确的值
      mid: window.$userInfo.mid_v2 || window.$userInfo.mid
    }

    let config = JSON.parse(JSON.stringify(apis[apiName]))
    if (config.method === 'get' || config.method === 'delete') {
      config.params = params || {}
      if (!noSign) {
        Object.assign(config.params, userBase)
      }
    } else {
      if (params.params) {
        config.params = JSON.parse(JSON.stringify(params.params))
        if (!noSign) {
          Object.assign(config.params, userBase)
        }
        delete params.params
      } else {
        config.params = noSign ? {} : JSON.parse(JSON.stringify(userBase))
      }

      if (!config.headers) {
        config.headers = {
          'Content-Type': 'application/json'
        }
      }

      if (config.headers && config.headers['Content-Type'] === 'multipart/form-data') {
        let formData = new FormData()
        for (let key in params) {
          formData.append(key, params[key])
        }
        config.data = formData
      } else {
        config.data = params
      }

    }

    if(getQueryString("debug") && getQueryString("kugouid")){
      if(config.params && config.params.platformAccountId){
        config.params.platformAccountId = getQueryString("kugouid");
      }
      if(config.data && config.data.platformAccountId){
        config.data.platformAccountId = getQueryString("kugouid");
      }
    }

    return noSign ? new Promise((resolve, reject) => {

      if (configs && configs.originRes) {
        window.rejectRes = null
        return resolve(request(config))
      }

      return request(config).then(res => {
        if (!res) return;
        if (res.data.code === 0) {
          // console.log(apis[apiName], res.data.data)
          window.rejectRes = null
          resolve(res.data)
        } else {
          e.emit('loading', false)
          window.$Msg('服务器异常，请稍后重试')
          window.rejectRes = res
          reject(res.data)
          console.error('接口报错', res.data)
        }
      }).catch(err => {
        e.emit('loading', false)
        window.$Msg('服务器异常，请稍后重试')
        window.rejectRes = null
        reject(err)
      })

    }) : new Promise((resolve, reject) => {

      infSign(config.params || null, config.data || null, {
        useH5: true,
        callback: function (sign) {
          Object.assign(config.params = config.params || {}, sign)
          if (configs && configs.originRes) {
            window.rejectRes = null
            return resolve(request(config))
          }

          return request(config).then(res => {
            if (!res) return;
            var errcode = res.data.errcode
            if (errcode === 0) {
              //console.log(apis[apiName], res.data.data)
              let gotData = res.data.data
              if (gotData && gotData.code && (gotData.code === 0 || gotData.code === '0')) {
                window.rejectRes = null;
                if(config.url.indexOf('/account/getUserInfo')!== -1){
                  apm.sucStat();
                }
                resolve(gotData)
              } else if (config.url.indexOf('get_face_status') !== -1 && res.data.errcode === 0) {
                //人脸识别接口返回没有gotData.code，特殊处理
                window.rejectRes = null
                resolve(gotData)
              } else if(config.url.indexOf('my_detail')!== -1 && res.data.errcode === 0){
                //无gotData.code
                window.rejectRes = null;
                apm.sucStat();
                resolve(gotData)
              } else if (config.url.indexOf('v1/settle_log_info') !== -1 && res.data.errcode === 0) {
                //获取上报类型返回没有gotData.code，特殊处理
                window.rejectRes = null
                resolve(gotData)
              } else {
                window.rejectRes = res
                reject(gotData)
              }
            } else {
              if(config.url.indexOf('/account/getUserInfo')!== -1){
                apm.errStat({
                  te: 'E1',
                  position: 1,
                  fs: `${errcode}_25`,
                  hash: res || '网络异常'
                })
              }else if(config.url.indexOf('my_detail')!== -1){
                apm.errStat({
                  te: 'E1',
                  position: 2,
                  fs: `${errcode}_25`,
                  hash: res || '网络异常'
                })
              }
              if (errcode == 20017) {
                window.$Msg('登录信息过期，请重新登录')
                setTimeout(() => {
                  window.$callLogin()
                }, 1000)
                return
              }
              e.emit('loading', false)
              window.$Msg('服务器异常，请稍后重试')
              // if (apis[apiName].errMsgs && apis[apiName].errMsgs[res.data.errcode]) {
              //   window.$Msg && window.$Msg.error(apis[apiName].errMsgs[res.data.errcode]) || reject(res.data)
              // } else {
              //   res.data.error_msg && window.$Msg && window.$Msg.error(res.data.error_msg) || reject(res.data)
              // }
              console.error('服务器错误', res.data)
              window.rejectRes = res//reject 只能传一个参数，避免过大改动
              reject( res.data.data || res.data )
            }
          }).catch(err => {
            if(config.url.indexOf('/account/getUserInfo')!== -1){
              apm.errStat({
                te: 'E3',
                position: 1,
                fs: '500_25',
                hash: err || '网络异常'
              })
            }else if(config.url.indexOf('my_detail')!== -1){
              apm.errStat({
                te: 'E3',
                position: 2,
                fs: '500_25',
                hash: err || '网络异常'
              })
            }
            e.emit('loading', false)
            window.$Msg('服务器异常，请稍后重试')
            window.rejectRes = null
            reject( err )
          })
        }
      })

    })

  }
}
